/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
// HERO "Atelier" (modelo_busca = 15): abertura EDITORIAL da home do modelo "Atelier" — sem foto
// em tela cheia (é o que o diferencia dos outros heros). Grade dividida ~56/44, altura
// min(88vh, 860px):
//  - esquerda: sobretítulo em versalete (cidade principal/empresa), TÍTULO enorme em serifa
//    (site.frase_busca, o mesmo campo dos heros 7/11/13/14; senão a frase padrão) — ESTÁTICO
//    (Daniel 15/10: sem a animação das palavras surgindo), e a BUSCA EM CAMPOS (Daniel 15/10:
//    "sem frase, estrutura de botões"): Negócio · Tipo de imóvel · Cidade · Bairro · Valor até → Ver
//    imóveis (Daniel 21/10: Tipo, Cidade e Bairro marcam VÁRIOS — utils/buscaMultiSelecao; o Bairro lista
//    os bairros das cidades marcadas; no cs834 o "Valor até" começa no piso de R$ 500 mil). Cada campo
//    é um botão com rótulo em versalete e valor em serifa que abre um LISTBOX próprio
//    (setas/Enter/Esc/Home/End, filtro por digitação nas listas longas, aria-activedescendant). A URL é a do hook compartilhado useHeroSearch (idêntica às buscas
//    existentes); o valor vira o `max` da faixa, com degraus dentro da faixa REAL do tenant (`valores`).
//    Links secundários: "Buscar por código" (mesma rota do hero Autoral) e "Busca avançada";
//    atalhos `allCards` (CardsBusca) numa linha discreta;
//  - direita: MOSAICO de fotos em 3 colunas (2 no tablet) deslizando devagar em sentidos
//    alternados (CSS, parado com movimento reduzido). SÓ FOTOS, decorativo (Daniel 15/10: "pegue
//    fotos aleatórias de imóveis, umas 40 no total, para deixar mais leve; apenas fotos, sem
//    permitir selecionar nada"): nada de link, legenda, hover ou foco — aria-hidden e sem eventos
//    de ponteiro. Fotos: DIRETO as dos IMÓVEIS (Daniel 15/10: nada de capa de vídeo/banner
//    aparecendo primeiro) — já no SSR, até 40 fotos dos imóveis dos carrosséis que a home traz
//    do servidor (`allCarrosseis`), em ordem pseudo-aleatória com SEMENTE fixa por tenant (a mesma
//    no servidor e no cliente: sem hidratação divergente); só se faltarem, depois de montar,
//    completa com o cache local da home / as novidades do tenant (acrescenta no fim, a ordem do
//    SSR não muda); só sem NENHUMA foto de imóvel cai nas fotos das cidades/banners do topo.
//    Mais leve: 2 cópias por coluna (não 3) e trilhos mais longos.
//    Sem nada: fotos de banco (public/atelier, Daniel 21/10: "pegue fotos aleatórias da internet mas nunca
//    fotos que não abrem") — e qualquer foto que falhe ao carregar troca por uma delas.
//    Celular: o mosaico vira UMA faixa horizontal (~170 px)
//    acima do título e cada lacuna, uma linha.
// SSR limpo: nada de Math.random/Date no render; o que depende de window só em efeito.
// Default export = ErrorBoundary com fallback (padrão WelcomeHorizonte/Aurora).
import { AnimatePresence, motion, MotionConfig } from 'framer-motion';
import { useRouter } from 'next/router';
import React, { useEffect, useId, useMemo, useRef, useState } from 'react';
import type { CSSProperties } from 'react';
import { alternarIdTexto, idsDoTexto, opcoesDoTexto, pisoPrecoVenda, resumoMarcados } from '../../../utils/buscaMultiSelecao';
import { removerAcentos } from '../../../utils/FunctionsGlobals';
import { getHomeScopedStorageKey } from '../../../utils/homeCache';
import { trackMetaEvent } from '../../../utils/metaPixel';
import { getWithTTL } from '../../../utils/storage';
import { normalizeHost } from '../../../utils/url';
import { useRegiao } from '../../context/Info';
import DrawerComponent from '../../drawer/DrawerComponent';
import type { HeroSectionProps } from '../../registry/types';
import CardsBusca from '../../shared/cards-busca/CardsBusca';
import { useHeroSearch } from '../../shared/hero-search/useHeroSearch';
import { useBairrosDasCidades } from '../../shared/multi-selecao/useBairrosDasCidades';
import {
    EASE_ATELIER,
    escadaDeValores,
    fotoOtimizada,
    fotosDoImovel,
    nomeDaEmpresa,
    stripHtml,
    useMovimentoReduzido,
    valorCompacto,
    varsAtelier,
} from '../atelier/atelier';
import type { OpcaoValor } from '../atelier/atelier';
import styles from './WelcomeAtelier.module.css';

const TITULO_PADRAO = 'Encontre o lugar onde a sua vida acontece.';
// 40 no desktop (Daniel 15/10); no celular a faixa horizontal usa 20 (2 cópias = 40 <img>).
const MAX_FOTOS = 40;
const MAX_FOTOS_CELULAR = 20;
// fotos por imóvel que entram no sorteio (engorda o pool sem buscar mais imóveis)
const FOTOS_POR_IMOVEL = 4;
const COLUNAS = 3;
// fotos de banco (Unsplash, licença livre) servidas pelo próprio site: nunca dependem de link de fora
const FOTOS_BANCO = Array.from({ length: 18 }, (_, i) => `/atelier/banco-${String(i + 1).padStart(2, '0')}.jpg`);

const IconeSeta = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="13 6 19 12 13 18" />
    </svg>
);
const IconeChevron = () => (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const normaliza = (v: unknown) => removerAcentos(String(v ?? '')).toLowerCase().trim();

/** Rótulo do campo "Negócio" (busca em campos, 15/10): venda → Comprar, aluguel → Alugar, temporada → Temporada. */
const rotuloDaTransacao = (value: string | undefined | null, label?: string): string => {
    const v = String(value ?? '').toLowerCase();
    if (v === 'venda') return 'Comprar';
    if (v === 'aluguel') return 'Alugar';
    if (v === 'temporada') return 'Temporada';
    const bruto = String(label || v || 'Comprar');
    return bruto.charAt(0).toUpperCase() + bruto.slice(1);
};

// ---------------------------------------------------------------------------
// Lacuna: campo-botão (rótulo em versalete + valor) que abre um listbox (popover) próprio.
// ---------------------------------------------------------------------------
interface ILacuna {
    id: string;
    rotulo: string;
    texto: string;
    valor: string;
    opcoes: OpcaoValor[];
    onChange: (_valor: string) => void;
    comBusca?: boolean;
    reduzido: boolean;
    /** marca VÁRIAS opções (Daniel 21/10): `valor` é o texto de ids "12,7" e a opção de valor '' limpa. */
    multiplo?: boolean;
    /** texto da lista sem nenhuma opção (ex.: Bairro sem cidade escolhida). */
    vazio?: string;
}

const Lacuna: React.FC<ILacuna> = ({ id, rotulo, texto, valor, opcoes, onChange, comBusca, reduzido, multiplo, vazio }) => {
    const [aberto, setAberto] = useState(false);
    const [termo, setTermo] = useState('');
    const [ativo, setAtivo] = useState(0);
    const raizRef = useRef<HTMLSpanElement | null>(null);
    const botaoRef = useRef<HTMLButtonElement | null>(null);
    const listaRef = useRef<HTMLUListElement | null>(null);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const idLista = `${id}-lista`;
    const idOpcao = (i: number) => `${id}-op-${i}`;

    const filtradas = useMemo(() => {
        const t = normaliza(termo);
        return t ? opcoes.filter((o) => normaliza(o.label).includes(t)) : opcoes;
    }, [opcoes, termo]);

    const marcados = multiplo ? idsDoTexto(valor) : [];
    const estaMarcada = (o: OpcaoValor) =>
        multiplo ? (String(o.value) === '' ? !marcados.length : marcados.includes(String(o.value))) : String(o.value) === valor;

    const abrir = () => {
        setTermo('');
        setAtivo(Math.max(0, opcoes.findIndex(estaMarcada)));
        setAberto(true);
    };
    const fechar = (devolverFoco = true) => {
        setAberto(false);
        if (devolverFoco) botaoRef.current?.focus();
    };
    const escolher = (o: OpcaoValor | undefined) => {
        if (!o) return;
        // múltiplo: cada opção liga/desliga e a lista fica aberta; a opção vazia ("Todas") limpa e fecha
        if (multiplo && String(o.value) !== '') {
            onChange(alternarIdTexto(valor, o.value));
            return;
        }
        onChange(String(o.value));
        fechar();
    };

    // foco entra na lista (ou no filtro); clique fora fecha.
    useEffect(() => {
        if (!aberto) return;
        const t = window.setTimeout(() => (comBusca ? inputRef.current : listaRef.current)?.focus(), 30);
        const fora = (e: PointerEvent) => {
            if (raizRef.current && !raizRef.current.contains(e.target as Node)) fechar(false);
        };
        document.addEventListener('pointerdown', fora);
        return () => {
            window.clearTimeout(t);
            document.removeEventListener('pointerdown', fora);
        };
    }, [aberto]);
    // a opção ativa fica sempre à vista.
    useEffect(() => {
        if (!aberto) return;
        const el = document.getElementById(idOpcao(ativo));
        if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'nearest' });
    }, [ativo, aberto, filtradas.length]);
    useEffect(() => setAtivo(0), [termo]);

    const teclado = (e: React.KeyboardEvent) => {
        const n = filtradas.length;
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setAtivo((a) => (n ? Math.min(n - 1, a + 1) : 0));
                break;
            case 'ArrowUp':
                e.preventDefault();
                setAtivo((a) => Math.max(0, a - 1));
                break;
            case 'Home':
                e.preventDefault();
                setAtivo(0);
                break;
            case 'End':
                e.preventDefault();
                setAtivo(Math.max(0, n - 1));
                break;
            case 'Enter':
                e.preventDefault();
                escolher(filtradas[ativo]);
                break;
            case ' ':
                if (!comBusca) {
                    e.preventDefault();
                    escolher(filtradas[ativo]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                e.stopPropagation();
                fechar();
                break;
            case 'Tab':
                fechar(false);
                break;
            default:
                break;
        }
    };

    return (
        <span className={styles.lacuna} ref={raizRef}>
            <button
                ref={botaoRef}
                type="button"
                className={`${styles.lacunaBotao} ${aberto ? styles.lacunaAberta : ''}`}
                aria-haspopup="listbox"
                aria-expanded={aberto}
                aria-controls={aberto ? idLista : undefined}
                aria-label={`${rotulo}: ${texto}`}
                onClick={() => (aberto ? fechar() : abrir())}
                onKeyDown={(e) => {
                    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !aberto) {
                        e.preventDefault();
                        abrir();
                    }
                }}
            >
                <span className={styles.lacunaRotulo}>{rotulo}</span>
                <span className={styles.lacunaValor}>
                    <span className={styles.lacunaTexto}>{texto}</span>
                    <span className={styles.lacunaChevron}>
                        <IconeChevron />
                    </span>
                </span>
            </button>
            <AnimatePresence>
                {aberto ? (
                    <motion.div
                        className={styles.popover}
                        initial={{ opacity: 0, y: reduzido ? 0 : 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: reduzido ? 0 : 4, transition: { duration: 0.12 } }}
                        transition={{ duration: reduzido ? 0 : 0.22, ease: EASE_ATELIER }}
                    >
                        {comBusca ? (
                            <input
                                ref={inputRef}
                                type="text"
                                className={styles.popoverBusca}
                                placeholder="Digite para filtrar"
                                autoComplete="off"
                                role="combobox"
                                aria-label={`Filtrar ${rotulo.toLowerCase()}`}
                                aria-expanded="true"
                                aria-autocomplete="list"
                                aria-controls={idLista}
                                aria-activedescendant={filtradas.length ? idOpcao(ativo) : undefined}
                                value={termo}
                                onChange={(e) => setTermo(e.target.value)}
                                onKeyDown={teclado}
                            />
                        ) : null}
                        <ul
                            ref={listaRef}
                            id={idLista}
                            role="listbox"
                            aria-label={rotulo}
                            tabIndex={comBusca ? -1 : 0}
                            aria-activedescendant={!comBusca && filtradas.length ? idOpcao(ativo) : undefined}
                            aria-multiselectable={multiplo || undefined}
                            onKeyDown={comBusca ? undefined : teclado}
                            className={styles.lista}
                        >
                            {filtradas.length === 0 ? (
                                <li className={styles.listaVazia} role="presentation">
                                    {!opcoes.length && vazio ? vazio : 'Nada encontrado'}
                                </li>
                            ) : null}
                            {filtradas.map((o, i) => {
                                const selecionada = estaMarcada(o);
                                return (
                                    <li
                                        key={`${o.value}-${i}`}
                                        id={idOpcao(i)}
                                        role="option"
                                        aria-selected={selecionada}
                                        className={`${styles.opcao} ${i === ativo ? styles.opcaoAtiva : ''} ${selecionada ? styles.opcaoSelecionada : ''}`}
                                        onPointerMove={() => setAtivo(i)}
                                        // o foco fica no filtro/lista: no múltiplo a lista segue aberta e o Esc ainda fecha
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => escolher(o)}
                                    >
                                        {o.label}
                                    </li>
                                );
                            })}
                        </ul>
                    </motion.div>
                ) : null}
            </AnimatePresence>
        </span>
    );
};

// ---------------------------------------------------------------------------
// Mosaico: fontes de foto (SSR + enriquecimento no cliente) e colunas deslizantes.
// ---------------------------------------------------------------------------
type Peca = { chave: string; src: string; alt: string };

/** Fisher–Yates — só no cliente (efeito), nunca no render: o SSR tem que ser determinístico. */
const embaralhar = <T,>(lista: T[]): T[] => {
    const out = lista.slice();
    for (let i = out.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [out[i], out[j]] = [out[j], out[i]];
    }
    return out;
};

const EXT_VIDEO_RE = /\.(mp4|webm|mov|m4v)(\?|$)/i;

/** Lê um cache da home (string JSON ou objeto) e devolve a lista plana de imóveis. */
const extrairImoveis = (bruto: unknown): any[] => {
    let v: any = bruto;
    if (typeof v === 'string') {
        try {
            v = JSON.parse(v);
        } catch {
            return [];
        }
    }
    if (!Array.isArray(v)) return [];
    const out: any[] = [];
    v.forEach((e: any) => {
        if (Array.isArray(e) && Array.isArray(e[1])) out.push(...e[1]);
        else if (e && typeof e === 'object' && e.id) out.push(e);
    });
    return out;
};

/** PRNG determinístico (mulberry32): a mesma semente dá a MESMA ordem no servidor e no cliente. */
const embaralharComSemente = <T,>(lista: T[], semente: number): T[] => {
    let s = (semente >>> 0) || 1;
    const rnd = () => {
        s = (s + 0x6d2b79f5) >>> 0;
        let t = s;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
    const out = lista.slice();
    for (let i = out.length - 1; i > 0; i--) {
        const j = Math.floor(rnd() * (i + 1));
        [out[i], out[j]] = [out[j], out[i]];
    }
    return out;
};

/** Pool: até FOTOS_POR_IMOVEL fotos de cada imóvel (sem repetir URL), embaralhado (com semente = determinístico,
 *  para o SSR; sem semente = Math.random, só no cliente) e cortado no teto. */
const fotosDosImoveis = (lista: any[], site: any, celular: boolean, semente?: number): Peca[] => {
    const pool: Peca[] = [];
    const vistos = new Set<string>();
    for (const im of lista) {
        if (!im?.id) continue;
        fotosDoImovel(im)
            .slice(0, FOTOS_POR_IMOVEL)
            .forEach((foto: string, n: number) => {
                if (!foto || vistos.has(foto)) return;
                vistos.add(foto);
                pool.push({ chave: `imovel-${im.id}-${n}`, src: fotoOtimizada(foto, site, celular), alt: '' });
            });
    }
    return (semente !== undefined ? embaralharComSemente(pool, semente) : embaralhar(pool)).slice(0, MAX_FOTOS);
};

const WelcomeAtelierInner: React.FC<HeroSectionProps> = ({ allCities, allTypes, allTransacao, site, urlBanner, origin, codsite, codsite2, setActiveDrawer, activeDrawer, favorito, isMobile1, props, allCards, valores, allCarrosseis }) => {
    const { transacoes, transacao, setTransacao, cidade, setCidade, tipo, setTipo, setBairros, precoMax, setPrecoMax, loading, setLoading, finalize, onSubmit, verImoveisUrl } = useHeroSearch({
        site,
        allCities,
        allTypes,
        allTransacao,
        codsite2,
        origin,
    });
    const router = useRouter();
    const { regiaoAtiva, modoPopup } = useRegiao();
    const reduzido = useMovimentoReduzido();
    const uid = useId().replace(/:/g, '');
    const celular = Boolean(isMobile1);
    const moeda = site?.moeda_tipo || 'R$';

    // ---- textos ----
    const titulo = useMemo(() => (site?.frase_busca ? stripHtml(site.frase_busca) : TITULO_PADRAO), [site?.frase_busca]);
    const subtitulo = useMemo(() => (site?.frase_busca_2 ? stripHtml(site.frase_busca_2) : ''), [site?.frase_busca_2]);
    const empresa = nomeDaEmpresa(site);
    // MULTI-FILIAIS (modo popup): a filial ativa dá nome à abertura ("Imóveis em Novo Hamburgo").
    const cidadePrincipal = String((modoPopup && regiaoAtiva?.nome) || site?.Dados?.cidade || '').trim();
    const sobretitulo = cidadePrincipal ? `Imóveis em ${cidadePrincipal}` : empresa;

    // ---- opções dos campos (busca em campos: rótulos de formulário, sem artigo/preposição) ----
    const opcoesTransacao: OpcaoValor[] = useMemo(() => transacoes.map((t) => ({ label: rotuloDaTransacao(t.value, t.label), value: String(t.value).toLowerCase() })), [transacoes]);
    const opcoesTipo: OpcaoValor[] = useMemo(
        () => {
            // tipos repetidos no cadastro (mesmo nome, ids diferentes) entram uma vez: a listagem é por nome
            const vistos = new Set<string>();
            const opcoes: OpcaoValor[] = [{ label: 'Todos os tipos', value: '' }];
            (allTypes || []).forEach((t: any) => {
                const label = String(t?.label ?? '').trim();
                const chave = normaliza(label);
                if (!label || vistos.has(chave)) return;
                vistos.add(chave);
                opcoes.push({ label, value: String(t?.value ?? '') });
            });
            return opcoes;
        },
        [allTypes]
    );
    const opcoesCidade: OpcaoValor[] = useMemo(
        () => [{ label: 'Todas as cidades', value: '' }].concat((allCities || []).map((c: any) => ({ label: String(c?.label ?? ''), value: String(c?.value ?? '') }))),
        [allCities]
    );
    const opcoesValor: OpcaoValor[] = useMemo(() => {
        const faixa = transacao === 'venda' ? valores?.precos_venda?.[0] : valores?.precos_locacao?.[0];
        // cs834 (utils/buscaMultiSelecao, Daniel 21/10): na venda o campo COMEÇA no piso (R$ 500 mil) — nenhum degrau abaixo
        const piso = transacao === 'venda' ? pisoPrecoVenda(site?.id, faixa?.max) : 0;
        const faixaCampo = piso ? { ...faixa, min: Math.max(Number(faixa?.min) || 0, piso - 1) } : faixa;
        // a escada vem como "até R$ X" (herança da frase); no campo "Valor até" o "até" é o rótulo
        return escadaDeValores(faixaCampo, transacao, moeda).map((o) => ({ ...o, label: o.value ? o.label.replace(/^até\s+/i, '') : 'Sem limite' }));
    }, [valores, transacao, moeda, site?.id]);
    // bairros das cidades marcadas (Daniel 21/10): o campo Bairro marca vários; mudou a lista (outras cidades) →
    // saem os que não estão mais nela, e o hook leva à URL os rótulos atuais
    const { bairros: listaBairros, carregando: carregandoBairros, idsCidades } = useBairrosDasCidades(cidade, origin, codsite || codsite2 || site?.id, allCities);
    const [bairrosMarcados, setBairrosMarcados] = useState('');
    useEffect(() => {
        const ficam = opcoesDoTexto(listaBairros, bairrosMarcados);
        const texto = ficam.map((b) => String(b.value)).join(',');
        if (texto !== bairrosMarcados) setBairrosMarcados(texto);
        setBairros(ficam);
    }, [listaBairros, bairrosMarcados]);
    const opcoesBairro: OpcaoValor[] = useMemo(
        () => (listaBairros.length ? [{ label: 'Todos os bairros', value: '' }].concat(listaBairros.map((b) => ({ label: String(b.label), value: String(b.value) }))) : []),
        [listaBairros]
    );
    const textoTransacao = opcoesTransacao.find((o) => o.value === transacao)?.label || rotuloDaTransacao(transacao);
    const textoTipo = resumoMarcados(opcoesDoTexto(opcoesTipo, tipo).map((o) => o.label), 'tipos') || 'Todos os tipos';
    const textoCidade = resumoMarcados(opcoesDoTexto(opcoesCidade, cidade).map((o) => o.label), 'cidades') || 'Todas as cidades';
    const textoBairro = resumoMarcados(opcoesDoTexto(opcoesBairro, bairrosMarcados).map((o) => o.label), 'bairros') || 'Todos os bairros';
    const vazioBairro = !idsCidades.length ? 'Escolha a cidade primeiro' : carregandoBairros ? 'Carregando bairros…' : 'Nenhum bairro cadastrado';
    const textoValor = precoMax ? valorCompacto(Number(precoMax), moeda) : 'Sem limite';
    const trocarTransacao = (v: string) => {
        setTransacao(v);
        setPrecoMax('');
    };

    // ---- busca por código (mesma rota do hero Autoral: código no 7º segmento) ----
    const [codigoAberto, setCodigoAberto] = useState(false);
    const [codigo, setCodigo] = useState('');
    const codigoRef = useRef<HTMLInputElement | null>(null);
    useEffect(() => {
        if (codigoAberto) codigoRef.current?.focus();
    }, [codigoAberto]);
    const buscarPorCodigo = (e: React.FormEvent) => {
        e.preventDefault();
        const termo = codigo.trim();
        if (!termo || loading) return;
        setLoading(true);
        trackMetaEvent(site, 'Search', { search_string: termo, transaction_type: transacao, content_category: 'hero_code_search' });
        router.push(finalize(`/imoveis/${transacao}/-/-/-/-/${removerAcentos(termo).replaceAll(' ', '%20')}`)).catch(() => setLoading(false));
    };

    // ---- mosaico: fotos dos IMÓVEIS já no SSR (carrosséis que a home traz do servidor) ----
    // Ordem pseudo-aleatória com SEMENTE fixa por tenant: a mesma no servidor e no cliente (hidratação
    // limpa) e diferente entre tenants. Nada de Math.random no render.
    const pecasSsrImoveis: Peca[] = useMemo(
        () => fotosDosImoveis(extrairImoveis(allCarrosseis), site, celular, Number(site?.id) || 1),
        [allCarrosseis, site?.id, site?.marca_dagua?.ativada, celular]
    );
    // reserva (só sem NENHUMA foto de imóvel): fotos das cidades do tenant e banners ativos do topo —
    // nunca a capa do vídeo (Daniel 15/10: "coloque direto fotos").
    const pecasReserva: Peca[] = useMemo(() => {
        const out: Peca[] = [];
        const vistos = new Set<string>();
        const add = (p: Peca) => {
            if (!p.src || vistos.has(p.src)) return;
            vistos.add(p.src);
            out.push(p);
        };
        (Array.isArray(props?.cidades) ? props.cidades : []).forEach((c: any) => {
            if (!c?.url_foto || !c?.nome) return;
            add({ chave: `cidade-${c.id ?? c.nome}`, src: String(c.url_foto), alt: '' });
        });
        (Array.isArray(props?.allBanners) ? props.allBanners : []).forEach((b: any) => {
            if (!b?.ativo || !b?.url || EXT_VIDEO_RE.test(String(b.url))) return;
            add({ chave: `banner-${b.id ?? b.url}`, src: String(b.url).replaceAll('"', ''), alt: '' });
        });
        if (urlBanner && urlBanner !== 'undefined') add({ chave: 'banner-topo', src: String(urlBanner).replaceAll('"', ''), alt: '' });
        return out;
    }, [props?.cidades, props?.allBanners, urlBanner]);

    // ---- complemento no cliente: só quando o SSR não encheu as 40 (cache da home / novidades do tenant) ----
    // Acrescenta no FIM: a ordem que o SSR pintou não muda (nada "pula" na tela).
    const [pecasExtras, setPecasExtras] = useState<Peca[]>([]);
    useEffect(() => {
        if (pecasSsrImoveis.length >= MAX_FOTOS) return;
        let cancelado = false;
        const carregar = async () => {
            try {
                // 1) o cache que a própria home grava ao montar os carrosséis (zero requisição).
                const host = normalizeHost(origin || site?.site || window.location.host);
                const codsiteCache = codsite2 || site?.id || 0;
                const total = Array.isArray(props?.carrosseis) ? props.carrosseis.length : 0;
                const slug = regiaoAtiva?.cidadeIds?.length ? regiaoAtiva?.slug || '' : '';
                const doCache = total > 0 ? extrairImoveis(getWithTTL<any>(getHomeScopedStorageKey('all_carrosseis', host, codsiteCache, total, slug))) : [];
                let pecas = fotosDosImoveis(doCache, site, celular);
                // 2) pool curto para 40 fotos: soma as novidades do tenant (mesma query/recorte regional da home).
                if (pecasSsrImoveis.length + pecas.length < MAX_FOTOS) {
                    const { imoveis_novidades } = await import('../../../services/properties');
                    const resultado = await imoveis_novidades('', origin, codsite2, '', regiaoAtiva?.cidadeIds?.length ? regiaoAtiva.cidadeIds : null, { quantidade: MAX_FOTOS });
                    const lista = Array.isArray(resultado?.imoveis_novidades) ? resultado.imoveis_novidades : [];
                    if (lista.length) pecas = fotosDosImoveis(lista.concat(doCache), site, celular);
                }
                const ja = new Set(pecasSsrImoveis.map((p) => p.src));
                const novas = pecas.filter((p) => p.src && !ja.has(p.src)).slice(0, MAX_FOTOS - pecasSsrImoveis.length);
                if (!cancelado && novas.length) setPecasExtras(novas);
            } catch {
                /* mosaico segue com o que o SSR trouxe */
            }
        };
        // deixa a home disparar as próprias buscas primeiro (e popular o cache).
        const t = window.setTimeout(carregar, 900);
        return () => {
            cancelado = true;
            window.clearTimeout(t);
        };
    }, [site?.id, codsite2, regiaoAtiva?.slug, pecasSsrImoveis.length]);

    const totalPecas = celular ? MAX_FOTOS_CELULAR : MAX_FOTOS;
    const pecas: Peca[] = useMemo(() => {
        const deImoveis = pecasSsrImoveis.concat(pecasExtras);
        // sem foto de imóvel nem de cidade/banner: fotos de banco (Daniel 21/10), nunca o mosaico vazio
        const fontes = deImoveis.length ? deImoveis : pecasReserva.length ? pecasReserva : FOTOS_BANCO.map((src, i) => ({ chave: `banco-${i}`, src, alt: '' }));
        return Array.from({ length: totalPecas }, (_, i) => {
            const f = fontes[i % fontes.length];
            return { ...f, chave: `${f.chave}-${Math.floor(i / fontes.length)}` };
        });
    }, [pecasSsrImoveis, pecasExtras, pecasReserva, totalPecas]);
    const colunas: Peca[][] = useMemo(() => {
        if (celular) return [pecas];
        return Array.from({ length: COLUNAS }, (_, c) => pecas.filter((_, i) => i % COLUNAS === c));
    }, [pecas, celular]);
    // trilhos ~3× mais longos que antes (40 fotos): a mesma velocidade de leitura pede ~3× o tempo
    const duracoes = ['150s', '184s', '166s'];

    // Foto que não abre (Daniel 21/10: "nunca fotos que não abrem") troca por uma de banco; se nem ela abrir, a
    // peça some. Mexe direto no <img> (o React não volta o src: a prop não mudou) e marca as tentativas no dataset.
    const trocarFotoQuebrada = (img: HTMLImageElement) => {
        const tentativas = Number(img.dataset.reserva || 0);
        if (tentativas >= 2) {
            img.parentElement?.style.setProperty('display', 'none');
            return;
        }
        img.dataset.reserva = String(tentativas + 1);
        const base = Number(img.dataset.idx || 0) + tentativas * 7;
        img.src = FOTOS_BANCO[base % FOTOS_BANCO.length];
    };
    // a que falhou ANTES da hidratação não dispara o onError do React: varre depois de montar (só as que
    // tentaram carregar — currentSrc vazio = lazy que ainda nem pediu a foto)
    const mosaicoRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        mosaicoRef.current?.querySelectorAll('img').forEach((img) => {
            if (img.complete && img.currentSrc && img.naturalWidth === 0) trocarFotoQuebrada(img);
        });
    }, [pecas]);

    // só foto (decorativa): sem link, legenda ou foco — o mosaico inteiro é aria-hidden.
    const renderPeca = (p: Peca, idx: number, copia: number) => {
        const eager = copia === 0 && idx < (celular ? 3 : 2);
        return (
            <span key={`${copia}-${p.chave}`} className={styles.peca}>
                <img
                    className={styles.foto}
                    src={p.src}
                    alt=""
                    loading={eager ? 'eager' : 'lazy'}
                    decoding="async"
                    draggable={false}
                    data-idx={idx}
                    onError={(e) => trocarFotoQuebrada(e.currentTarget)}
                />
            </span>
        );
    };

    const varsHero = {
        ...varsAtelier(site),
    } as CSSProperties;

    return (
        <MotionConfig reducedMotion="user">
            <section className={`${styles.atelier} ${reduzido ? styles.semMovimento : ''}`} data-builder-section="busca" style={varsHero}>
                <DrawerComponent site={site} activeDrawer={activeDrawer} setActiveDrawer={setActiveDrawer} favorito={favorito || []} menus={props?.menus} />

                <div className={styles.grade}>
                    {/* ---------- editorial ---------- */}
                    <div className={styles.editorial}>
                        {sobretitulo ? (
                            <p className={styles.sobretitulo}>
                                <span className={styles.sobretituloLinha} aria-hidden="true" />
                                <span>{sobretitulo}</span>
                            </p>
                        ) : null}
                        <h1 className={styles.titulo}>{titulo}</h1>
                        {subtitulo ? <p className={styles.subtitulo}>{subtitulo}</p> : null}

                        {/* id="myLink": âncora do botão "BUSCA AVANÇADA" do topo (topo2). Busca em CAMPOS (15/10):
                            5 campos-botão + "Ver imóveis", sem a frase. */}
                        <form id="myLink" className={styles.campos} onSubmit={onSubmit} aria-label="Busca de imóveis">
                            <Lacuna id={`at-${uid}-neg`} rotulo="Negócio" texto={textoTransacao} valor={transacao} opcoes={opcoesTransacao} onChange={trocarTransacao} reduzido={reduzido} />
                            <Lacuna id={`at-${uid}-tipo`} rotulo="Tipo de imóvel" texto={textoTipo} valor={tipo} opcoes={opcoesTipo} onChange={setTipo} comBusca={opcoesTipo.length > 8} reduzido={reduzido} multiplo />
                            <Lacuna id={`at-${uid}-cid`} rotulo="Cidade" texto={textoCidade} valor={cidade} opcoes={opcoesCidade} onChange={setCidade} comBusca={opcoesCidade.length > 6} reduzido={reduzido} multiplo />
                            <Lacuna id={`at-${uid}-bai`} rotulo="Bairro" texto={textoBairro} valor={bairrosMarcados} opcoes={opcoesBairro} onChange={setBairrosMarcados} comBusca={opcoesBairro.length > 8} reduzido={reduzido} multiplo vazio={vazioBairro} />
                            <Lacuna id={`at-${uid}-val`} rotulo="Valor até" texto={textoValor} valor={precoMax} opcoes={opcoesValor} onChange={setPrecoMax} reduzido={reduzido} />
                            <button type="submit" className={styles.ver} disabled={loading} title="Ver imóveis">
                                <span>{loading ? 'Buscando…' : 'Ver imóveis'}</span>
                                <span className={styles.verSeta}>
                                    <IconeSeta />
                                </span>
                            </button>
                        </form>

                        <div className={styles.secundarios}>
                            <button type="button" className={styles.secundario} aria-expanded={codigoAberto} aria-controls={`at-${uid}-codigo`} onClick={() => setCodigoAberto((v) => !v)}>
                                Buscar por código
                            </button>
                            <span className={styles.secundarioSep} aria-hidden="true">
                                ·
                            </span>
                            <a
                                href={verImoveisUrl}
                                className={styles.secundario}
                                data-no-quicklink
                                data-no-instant
                                data-no-prefetch
                                onClick={() => trackMetaEvent(site, 'ViewContent', { content_name: 'Busca avançada', content_category: 'property_search' })}
                            >
                                Busca avançada
                            </a>
                        </div>
                        <AnimatePresence initial={false}>
                            {codigoAberto ? (
                                <motion.form
                                    id={`at-${uid}-codigo`}
                                    className={styles.codigo}
                                    role="search"
                                    onSubmit={buscarPorCodigo}
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: 'auto' }}
                                    exit={{ opacity: 0, height: 0 }}
                                    transition={{ duration: reduzido ? 0 : 0.3, ease: EASE_ATELIER }}
                                >
                                    <label htmlFor={`at-${uid}-codigo-input`} className={styles.codigoRotulo}>
                                        Código do imóvel
                                    </label>
                                    <div className={styles.codigoCampo}>
                                        <input
                                            ref={codigoRef}
                                            id={`at-${uid}-codigo-input`}
                                            type="text"
                                            inputMode="search"
                                            autoComplete="off"
                                            placeholder="Ex.: 1234"
                                            className={styles.codigoInput}
                                            value={codigo}
                                            onChange={(e) => setCodigo(e.target.value)}
                                        />
                                        <button type="submit" className={styles.codigoBotao} disabled={loading || !codigo.trim()} aria-label="Buscar imóvel pelo código">
                                            <IconeSeta />
                                        </button>
                                    </div>
                                </motion.form>
                            ) : null}
                        </AnimatePresence>

                        <CardsBusca cards={allCards} site={site} variante="claro" className={styles.cards} />
                    </div>

                    {/* ---------- mosaico ---------- */}
                    <div ref={mosaicoRef} className={`${styles.mosaico} ${celular ? styles.mosaicoFaixa : ''}`} aria-hidden="true">
                        {colunas.map((col, c) => (
                            <div key={c} className={styles.coluna}>
                                <div className={`${styles.trilho} ${c % 2 === 1 ? styles.trilhoDesce : ''}`} style={{ animationDuration: duracoes[c % duracoes.length] }}>
                                    {/* 2 cópias: o laço anda 1/2; com 40 fotos uma cópia já é bem mais alta que a coluna */}
                                    {col.map((p, i) => renderPeca(p, i, 0))}
                                    {col.map((p, i) => renderPeca(p, i, 1))}
                                </div>
                            </div>
                        ))}
                        <span className={styles.mosaicoVeuTopo} aria-hidden="true" />
                        <span className={styles.mosaicoVeuBase} aria-hidden="true" />
                    </div>
                </div>
            </section>
        </MotionConfig>
    );
};

class WelcomeAtelier extends React.Component<HeroSectionProps, { hasError: boolean }> {
    constructor(props: HeroSectionProps) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch() {
        // silencioso: degrada pro fallback sem quebrar a home.
    }
    render() {
        const { fallback, site } = this.props;
        if (this.state.hasError || !site) return fallback ?? null;
        return <WelcomeAtelierInner {...this.props} />;
    }
}

export default WelcomeAtelier;
